import * as CryptoJS from 'crypto-js';

export const key1 = '08277A08B0ABA70703E28A5FCED7396D';
export const key2 = 'D9062EA86462F77E';

export function encryptUsingAES256(data, aesSecretKey = key1, aesSecretIVKey = key2) {
	if (typeof data === 'number') {
		var name = data.toString();
	} else if (typeof data === 'boolean') {
		var name = data.toString();
	} else {
		name = data;
	}

	const _key = CryptoJS.enc.Utf8.parse(aesSecretKey);
	const _iv = CryptoJS.enc.Utf8.parse(aesSecretIVKey);
	const encrypted = CryptoJS.AES.encrypt(name, _key, {
		keySize: 256 / 32,
		iv: _iv,
		mode: CryptoJS.mode.CBC,
	});
	const encryptedString = encrypted.toString();
	const encryptedData = base64toHEX(encryptedString);
	return encryptedData;
}

export function base64toHEX(base64) {
	const raw = atob(base64);
	let HEX = '';
	let i;
	for (i = 0; i < raw.length; i++) {
		const _hex = raw.charCodeAt(i).toString(16);
		HEX += _hex.length === 2 ? _hex : '0' + _hex;
	}

	return HEX;
}

export function decryptUsingAES256(
	encrypted,
	aesSecretKey = key1,
	aesSecretIVKey = key2
) {
	const _key = CryptoJS.enc.Utf8.parse(aesSecretKey);
	const _iv = CryptoJS.enc.Utf8.parse(aesSecretIVKey);
	const base64String = btoa(
		encrypted
			.match(/\w{2}/g)
			.map((a) => {
				return String.fromCharCode(Number.parseInt(a, 16));
			})
			.join('')
	);
	const decrypted = CryptoJS.AES.decrypt(base64String, _key, {
		keySize: 256 / 32,
		iv: _iv,
		mode: CryptoJS.mode.CBC,
	}).toString(CryptoJS.enc.Utf8);
	return decrypted;
}
